<div fxLayout="column" class="content-container" fxLayoutGap="10px">
  <mat-progress-bar class="default-progress-bar" mode="indeterminate" color="primary" *ngIf="isLoading"></mat-progress-bar>
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters"
                   (selectedItemsChanged)="onSelectedItemsChanged($event)"
                   [selectedItemsChange]="selectedFilterChange"
                   [hideSearchInput]="true"
                   [showFilterButton]="false"
                   [showDateRange]="true" [defaultDateRange]="dateRangeService.selectedDateRange?.action || 0"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    <app-filter-row-additional-content fxLayout="row" fxLayoutGap="5px">
      <button mat-stroked-button (click)="onRefreshClicked()" class="only-icon">
        <mat-icon>refresh</mat-icon>
      </button>
      <!--<mat-button-toggle-group name="ingredients" multiple (valueChange)="onActionButtonsClicked($event)">
        <mat-button-toggle value="internalCalls"><mat-icon>phone_callback</mat-icon></mat-button-toggle>
      </mat-button-toggle-group>-->
    </app-filter-row-additional-content>
  </app-grid-filter>

  <!-- Dashboard: Stats -->
  <div class="row total-rubic">
    <div class="col-sm-12 col-lg">
      <app-dashboard-card title="Incoming Calls" [value]="grandTotals.isIncoming" secondIconClass="fa-arrow-down" [backgroundColor]="colors.primaryGreen"></app-dashboard-card>
    </div>
    <div class="col-sm-12 col-lg">
      <app-dashboard-card title="Outgoing Calls" [value]="grandTotals.isOutgoing" secondIconClass="fa-arrow-up" [backgroundColor]="colors.primaryBlue"></app-dashboard-card>
    </div>
    <div class="col-sm-12 col-lg">
      <app-dashboard-card title="Missed Calls" [value]="grandTotals.isMissed" secondIconClass="fa-plus" [backgroundColor]="colors.primaryRed"></app-dashboard-card>
    </div>
    <div class="col-sm-12 col-lg">
      <app-dashboard-card title="Mailbox Calls" [value]="grandTotals.isMailbox" secondIconClass="fa-envelope no-rotate" [backgroundColor]="colors.orange"></app-dashboard-card>
    </div>
    <div class="col-sm-12 col-lg">
      <app-dashboard-card title="Avg. Talk Time" [value]="grandTotals.avgTalkDuration" [showAsDuration]="true" secondIconClass="fa-clock-o no-rotate" [backgroundColor]="colors.teal"></app-dashboard-card>
    </div>
  </div>

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
    <mat-card appearance="outlined" fxFlex>
      <mat-card-content id="chartContainer1">
        <div style="height: 375px">
          <app-activity-chart [data]="timeSeriesTotals" [chartType]="timeSeriesType" [showExpand]="true"
                              [startDate]="additionalFilter.startDate" [endDate]="additionalFilter.endDate"></app-activity-chart>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" fxFlex>
      <mat-card-content id="chartContainer2">
        <div style="height: 375px">
          <app-activity-pie-chart [data]="pieChartData" [showExpand]="true"></app-activity-pie-chart>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
    <mat-card appearance="outlined" fxFlex>
      <mat-card-title>Groups</mat-card-title>
      <mat-card-content>
        <div class="items-container list-group">
          <ng-template ngFor let-item [ngForOf]="topByGroups" let-i="index">
            <div class="top-item--title list-group-item">
              <span style="width: 40px; display: inline-block">{{i + 1}}</span>
              <span>{{reportsService.getExtensionName(item.number)}}</span>
            </div>
            <div class="top-item list-group-item">
              <div class="progress progress-info top-progress">
                <div class="progress-bar progress-bar-success" [style.width]="item.percentValue.toFixed(2) + '%'">
                </div>
              </div>
              <span class="top-item--text" >{{item.totalCount}} Incoming</span>
            </div>
          </ng-template>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" fxFlex>
      <mat-card-title>Agents</mat-card-title>
      <mat-card-content>
        <div class="items-container list-group">
          <ng-template ngFor let-item [ngForOf]="topByUsers" let-i="index">
            <div class="top-item--title list-group-item">
              <span style="width: 40px; display: inline-block">{{i + 1}}</span>
              <span>{{reportsService.getExtensionName(item.number)}}</span>
            </div>

            <div class="top-item list-group-item">
              <div class="progress progress-info top-progress">
                <div class="progress-bar progress-bar-incoming" [style.width]="item.percentAllValue.toFixed(2) + '%'">
                </div>
              </div>
              <span class="top-item--text" >{{item.totalCount}} In / {{item.outTotalCount}} Out</span>
            </div>
          </ng-template>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

